/**
 * @file Adds decimal strings exactly and writes the sum at the largest scale
 * among them, so `"0.1"` and `"0.20"` give `"0.30"`; an empty list gives
 * `"0"`. Consumers: the Overview figures, rows and months. It throws on a
 * string that is not a decimal, so callers verify each cell first.
 */
import { analyticsDecimalFraction } from './analyticsDecimalFraction';
import { analyticsFractionDecimal } from './analyticsFractionDecimal';

export const analyticsDecimalSum = (decimals: readonly string[]): string => {
  const fractions = decimals.map((decimal) => {
    const fraction = analyticsDecimalFraction(decimal);
    if (fraction === undefined)
      throw new Error(`"${decimal}" is not a decimal.`);
    return fraction;
  });
  const denominator = fractions.reduce(
    (largest, fraction) =>
      fraction.denominator > largest ? fraction.denominator : largest,
    1n,
  );
  const numerator = fractions.reduce(
    (sum, fraction) =>
      sum + fraction.numerator * (denominator / fraction.denominator),
    0n,
  );
  return analyticsFractionDecimal(
    { numerator, denominator },
    denominator.toString().length - 1,
  );
};
